import {Box, HStack, Icon, Link, Text, VStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import {EMPTY_PLACEHOLDER} from '../../constants/placeholders';
import {getFileIcon} from '../../utils/getFileIcon';
import {MessageText} from '../EmailLeadPreviewDialog/MessageText';

export interface SentMessageAttachment {
  id: string;
  title: string;
  remoteUrl: string;
  contentType?: string | null;
}

export interface SentMessagePreviewDialogProps {
  body: string;
  recipient: string;
  sender: string;
  sentAt: string;
  subject: string;
  attachments?: SentMessageAttachment[];
}

export function SentMessagePreviewDialog(props: SentMessagePreviewDialogProps) {
  const formatDateTime = useDateTimeFormatter();

  return (
    <HStack spacing={4} maxHeight="70vh">
      <Box
        flexGrow={1}
        maxHeight="100%"
        width="70%"
        backgroundColor="palettes.neutral.20.100"
        borderRadius="medium"
        padding={4}
        overflowY="auto"
      >
        <HStack justify="center" align="center">
          <Box height="100%" width={150} padding={10} backgroundColor="general.white">
            <MessageText htmlData={props.body} />
          </Box>
        </HStack>
      </Box>

      <Box
        flexGrow={1}
        width="30%"
        backgroundColor="palettes.neutral.20.100"
        borderRadius="medium"
        padding={4}
      >
        <VStack spacing={4}>
          <VStack spacing={1}>
            <Text size="xSmall" color="secondary">
              {i18n.t('entity.email.labels.subject')}
            </Text>
            <Text size="small">{props.subject}</Text>
          </VStack>

          <VStack spacing={1}>
            <Text size="xSmall" color="secondary">
              {i18n.t('entity.email.labels.recipient')}
            </Text>
            <Text size="small">{props.recipient}</Text>
          </VStack>

          <VStack spacing={1}>
            <Text size="xSmall" color="secondary">
              {i18n.t('entity.email.labels.sender')}
            </Text>
            <Text size="small">{props.sender}</Text>
          </VStack>

          <VStack spacing={1}>
            <Text size="xSmall" color="secondary">
              {i18n.t('entity.email.labels.sentAt')}
            </Text>
            <Text size="small">
              {props.sentAt === EMPTY_PLACEHOLDER
                ? props.sentAt
                : formatDateTime('dateTimeShort', parseDate(props.sentAt))}
            </Text>
          </VStack>

          {props.attachments && props.attachments.length > 0 && (
            <VStack spacing={1}>
              <Text size="xSmall" color="secondary">
                {i18n.t('entity.email.labels.attachments')}
              </Text>
              <VStack spacing={1}>
                {props.attachments.map((attachment) => (
                  <HStack spacing={1} align="center" key={attachment.id}>
                    <Icon value={getFileIcon(attachment.contentType)} size={4} />
                    <Link
                      href={attachment.remoteUrl}
                      target="_blank"
                      size="small"
                      title={attachment.title}
                    />
                  </HStack>
                ))}
              </VStack>
            </VStack>
          )}
        </VStack>
      </Box>
    </HStack>
  );
}
